import { QueryClient, useQueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
    },
  },
});

export const useQueryCached = <T>(key: string[]) => {
  const queryClient = useQueryClient();
  return queryClient.getQueryData(key) as T;
};

export default queryClient;
